import _                     from 'lodash'
import React                 from 'react'
import { Button, Glyphicon } from 'react-bootstrap'

export default GlyphButton = (props) ->
  <Button {..._.omit(props, 'glyph')} >
    <Glyphicon glyph={props.glyph} />
  </Button>
